<template>
  <div class="container">
    <div class="left-box">
      <div class="top-title">信息填写</div>
      <div class="form-box">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="col">
            <el-form-item label="企业名称" prop="entName" class="col-form-item">
              <el-input v-model="ruleForm.entName" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系人" class="col-form-item">
              <el-input
                v-model="ruleForm.contact"
                placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item
              label="联系电话"
              prop="concatTel"
              class="col-form-item"
            >
              <el-input
                v-model="ruleForm.contactTel"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业类型" prop="entType" class="col-form-item">
              <el-select
                v-model="ruleForm.entType"
                placeholder="请选择企业类型"
                class="select-box"
              >
                <el-option
                  v-for="item in entTypeList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="企业地址" class="col-form-item">
              <el-input
                v-model="ruleForm.address"
                placeholder="请输入企业地址"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="办公地址"
              prop="workAddress"
              class="col-form-item"
            >
              <el-input
                v-model="ruleForm.workAddress"
                placeholder="请输入办公地址"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item
            label="营业执照正副本原件及复印件"
            class="col-form-item"
            prop="pictures"
          >
            <el-upload
              class="upload-demo"
              :action="uploadFileApi"
              :headers="uploadHeader"
              :accept="acceptUploadType"
              :limit="5"
              :on-success="
                (response, file, fileList) => {
                  return handleUploadSuccess(
                    response,
                    file,
                    fileList,
                    'pictures'
                  )
                }
              "
              :before-upload="
                (file) => {
                  return beforeUploadFile(file, 'pictures')
                }
              "
              :on-remove="
                (file, fileList) => handleRemove(file, fileList, 'pictures')
              "
              :file-list="pictures"
              :on-preview="handlePreview"
              :on-exceed="handleExceed"
            >
              <el-button icon="el-icon-plus" size="small">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                {{ tips }}
              </div>
            </el-upload>
          </el-form-item>

          <div class="col">
            <el-form-item label="上年年产值（万元）" class="col-form-item">
              <el-input
                v-model="ruleForm.outputValue"
                placeholder="请输入上年年产值"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item label="上年年营业收入（万元）" class="col-form-item">
              <el-input
                v-model="ruleForm.businessIncome"
                placeholder="请输入上年年营业收入"
                type="number"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="上年出口总额（万元）" class="col-form-item">
              <el-input
                v-model="ruleForm.totalExport"
                placeholder="请输入上年出口总额"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item label="上年实缴税收（万元）" class="col-form-item">
              <el-input
                v-model="ruleForm.taxRevenue"
                placeholder="请输入上年实缴税收"
                type="number"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="上年利润总额（万元）" class="col-form-item">
              <el-input
                v-model="ruleForm.totalProfit"
                placeholder="请输入上年利润总额"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item label="上年工资总额（万元）" class="col-form-item">
              <el-input
                v-model="ruleForm.grossSalary"
                placeholder="请输入上年工资总额"
                type="number"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item
              label="上年研发经费总额（万元）"
              class="col-form-item"
            >
              <el-input
                v-model="ruleForm.totalResearch"
                placeholder="请输入上年研发经费总额"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item label="上年固定资产（万元）" class="col-form-item">
              <el-input
                v-model="ruleForm.fixAssets"
                placeholder="请输入上年固定资产"
                type="number"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col">
            <el-form-item label="上年资产总额（万元）" class="col-form-item">
              <el-input
                v-model="ruleForm.totalAssets"
                placeholder="请输入上年资产总额"
                type="number"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="从业人数"
              prop="workNumber"
              class="col-form-item"
            >
              <el-input
                type="number"
                v-model="ruleForm.workNumber"
                placeholder="请输入从业人数"
              ></el-input>
            </el-form-item>
          </div>

          <el-form-item
            label="上年度营业收入（利润表）"
            class="col-form-item"
            prop="pictures2"
          >
            <el-button type="text" @click="downFile(4)"
              >点击下载上年度营业收入（利润表）模版</el-button
            >
            <el-upload
              class="upload-demo"
              :action="uploadFileApi"
              :headers="uploadHeader"
              :limit="5"
              :accept="acceptUploadType"
              :on-success="
                (response, file, fileList) => {
                  return handleUploadSuccess(
                    response,
                    file,
                    fileList,
                    'pictures2'
                  )
                }
              "
              :before-upload="
                (file) => {
                  return beforeUploadFile(file, 'pictures2')
                }
              "
              :file-list="pictures2"
              :on-remove="
                (file, fileList) => handleRemove(file, fileList, 'pictures2')
              "
              :on-preview="handlePreview"
              :on-exceed="handleExceed"
            >
              <el-button icon="el-icon-plus" size="small">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                {{ tips }}
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="社会保险参保证明"
            class="col-form-item"
            prop="pictures3"
          >
            <el-upload
              class="upload-demo"
              :action="uploadFileApi"
              :headers="uploadHeader"
              :limit="5"
              :accept="acceptUploadType"
              :on-success="
                (response, file, fileList) => {
                  return handleUploadSuccess(
                    response,
                    file,
                    fileList,
                    'pictures3'
                  )
                }
              "
              :before-upload="
                (file) => {
                  return beforeUploadFile(file, 'pictures3')
                }
              "
              :on-remove="
                (file, fileList) => handleRemove(file, fileList, 'pictures3')
              "
              :file-list="pictures3"
              :on-preview="handlePreview"
              :on-exceed="handleExceed"
            >
              <el-button icon="el-icon-plus" size="small">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                {{ tips }}
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="上年度纳税证明"
            class="col-form-item"
            prop="pictures7"
          >
            <el-upload
              class="upload-demo"
              :action="uploadFileApi"
              :headers="uploadHeader"
              :limit="5"
              :accept="acceptUploadType"
              :on-success="
                (response, file, fileList) => {
                  return handleUploadSuccess(
                    response,
                    file,
                    fileList,
                    'pictures7'
                  )
                }
              "
              :before-upload="
                (file) => {
                  return beforeUploadFile(file, 'pictures7')
                }
              "
              :on-remove="
                (file, fileList) => handleRemove(file, fileList, 'pictures7')
              "
              :file-list="pictures7"
              :on-preview="handlePreview"
              :on-exceed="handleExceed"
            >
              <el-button icon="el-icon-plus" size="small">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                {{ tips }}
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item
            label="额度两万元的优质中小微企业证明材料"
            class="col-form-item"
          >
            <el-upload
              class="upload-demo"
              :action="uploadFileApi"
              :headers="uploadHeader"
              :limit="5"
              :accept="acceptUploadType"
              :on-success="
                (response, file, fileList) => {
                  return handleUploadSuccess(
                    response,
                    file,
                    fileList,
                    'pictures4'
                  )
                }
              "
              :before-upload="
                (file) => {
                  return beforeUploadFile(file, 'pictures4')
                }
              "
              :on-remove="
                (file, fileList) => handleRemove(file, fileList, 'pictures4')
              "
              :file-list="pictures4"
              :on-preview="handlePreview"
              :on-exceed="handleExceed"
            >
              <el-button icon="el-icon-plus" size="small">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                {{ tips }}
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item
            label="入驻企业承诺书"
            class="col-form-item"
            prop="pictures5"
          >
            <el-button type="text" @click="downFile(1)"
              >点击下载入驻企业承诺书模版</el-button
            >
            <el-upload
              class="upload-demo"
              :action="uploadFileApi"
              :headers="uploadHeader"
              :limit="5"
              :accept="acceptUploadType"
              :on-success="
                (response, file, fileList) => {
                  return handleUploadSuccess(
                    response,
                    file,
                    fileList,
                    'pictures5'
                  )
                }
              "
              :before-upload="
                (file) => {
                  return beforeUploadFile(file, 'pictures5')
                }
              "
              :on-remove="
                (file, fileList) => handleRemove(file, fileList, 'pictures5')
              "
              :file-list="pictures5"
              :on-preview="handlePreview"
              :on-exceed="handleExceed"
            >
              <el-button icon="el-icon-plus" size="small">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                {{ tips }}
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="信用承诺书"
            class="col-form-item"
            prop="pictures6"
          >
            <el-button type="text" @click="downFile(2)"
              >点击下载信用承诺书模版</el-button
            >
            <el-upload
              class="upload-demo"
              :action="uploadFileApi"
              :headers="uploadHeader"
              :limit="5"
              :accept="acceptUploadType"
              :on-success="
                (response, file, fileList) => {
                  return handleUploadSuccess(
                    response,
                    file,
                    fileList,
                    'pictures6'
                  )
                }
              "
              :before-upload="
                (file) => {
                  return beforeUploadFile(file, 'pictures6')
                }
              "
              :on-remove="
                (file, fileList) => handleRemove(file, fileList, 'pictures6')
              "
              :file-list="pictures6"
              :on-preview="handlePreview"
              :on-exceed="handleExceed"
            >
              <el-button icon="el-icon-plus" size="small">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                {{ tips }}
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item>
            <el-checkbox v-model="checkCommitment"
              ><span style="color: red">*</span
              >我司承诺上述表格中所填写的内容真实有效</el-checkbox
            >
          </el-form-item>

          <el-form-item>
            <el-popover v-model="visible" popper-class="popover-back">
              <div class="flex">
                <div>
                  <i class="el-icon-warning warningColor"></i>
                </div>
                <div>
                  <p class="title">返回将不保存当前页面编辑信息</p>
                  <p class="content">是否确认返回？</p>
                </div>
              </div>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="plain" @click="visible = false"
                  >取消</el-button
                >
                <el-button type="primary" size="mini" @click="backToList()"
                  >确认</el-button
                >
              </div>
              <el-button slot="reference">返回</el-button>
            </el-popover>
            <el-button
              class="submitBtn"
              type="primary"
              @click="submitForm('ruleForm')"
              :disabled="!checkCommitment"
            >
              提交</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <auditRecord
      :recordList="recordList"
      v-if="recordList.length"
    ></auditRecord>

    <el-image-viewer
      v-if="isPreview"
      :on-close="
        () => {
          isPreview = false
        }
      "
      :url-list="[previewUrl]"
    >
    </el-image-viewer>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import auditRecord from './components/auditRecord'
import { downEntWhiteModel } from '@api/yardIntermediary/applicationResidency'
import { isPhone, getToken } from '@utils'
import {
  insertOrUpdate,
  listRecords,
  entWhiteDetail,
  getEntType,
  uploadFileByContentType
} from '@api/yardVoucher/whiteListApplication/index'
export default {
  name: 'WhiteApplyDetail',
  components: { auditRecord, ElImageViewer },
  data() {
    return {
      tips: '支持.doc, .docx, .xls, .xlsx, .png, .jpg, .pdf格式，数量最多5个',
      acceptUploadType: '.doc, .docx, .xls, .xlsx, .png, .jpg, .pdf',
      ruleForm: {
        entName: '',
        contact: '',
        id: ''
      },
      rules: {
        workAddress: [
          { required: true, message: '请输入办公地址', trigger: 'blur' }
        ],
        entType: [
          { required: true, message: '请选择企业类型', trigger: 'change' }
        ],
        concatTel: [isPhone('手机号')],

        workNumber: [
          { required: true, message: '请输入从业人数', trigger: 'blur' }
        ],
        pictures: [
          {
            required: true,
            message: '请上传营业执照正副本原件及复印件',
            trigger: 'change'
          }
        ],
        pictures2: [
          {
            required: true,
            message: '请上传上年度营业收入（利润表）',
            trigger: 'change'
          }
        ],
        pictures3: [
          {
            required: true,
            message: '请上传社会保险参保证明',
            trigger: 'change'
          }
        ],
        pictures7: [
          {
            required: true,
            message: '请上传上年度纳税证明',
            trigger: 'change'
          }
        ],
        pictures5: [
          {
            required: true,
            message: '请上传入驻企业承诺书',
            trigger: 'change'
          }
        ],
        pictures6: [
          {
            required: true,
            message: '请上传入驻企业承诺书',
            trigger: 'change'
          }
        ]
      },
      entTypeList: [], // 企业类型
      pictures: [],
      pictures2: [],
      pictures3: [],
      pictures7: [],
      pictures4: [],
      pictures5: [],
      pictures6: [],
      rulesList: [
        'pictures',
        'pictures2',
        'pictures3',
        'pictures7',
        'pictures5',
        'pictures6'
      ],
      recordList: [],
      visible: false,
      uploadFileApi: uploadFileByContentType,
      checkCommitment: false,
      isPreview: false,
      previewUrl: '',
      creditCode: '',
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      }
    }
  },
  async mounted() {
    await this.getEntTypeList()
    await this.getEntWhiteDetail()
    this.getListRecords()
  },
  methods: {
    // 入驻申请模板下载  1-入驻企业承诺书模板 2-信用承诺书模板 3-服务机构入驻承诺书模板 4-上年度营业收入（利润表）
    downFile(num) {
      let params = {
        moduleType: num
      }
      downEntWhiteModel(params).then((res) => {
        const result = res.data
        if (result.code === '0000') {
          window.open(result.data, '_blank')
        }
      })
    },
    getListRecords() {
      let params = {
        creditCode: this.creditCode || ''
      }
      listRecords(params).then((res) => {
        if (res.data.code == '0000') {
          this.recordList = res.data.data || []
        }
      })
    },
    getEntTypeList() {
      return new Promise((resolve) => {
        getEntType().then((res) => {
          if (res.data.code == '0000') {
            this.entTypeList = res.data.data
            resolve()
          }
        })
      })
    },
    getEntWhiteDetail() {
      return new Promise((resolve) => {
        entWhiteDetail().then((res) => {
          const { code, msg, data } = res.data
          if (code == '0000') {
            this.creditCode = data.creditCode
            let {
              creditCode,
              id,
              entName,
              contact,
              contactTel,
              entType,
              address,
              workAddress,
              pictures,
              outputValue,
              businessIncome,
              totalExport,
              taxRevenue,
              totalProfit,
              grossSalary,
              totalResearch,
              fixAssets,
              totalAssets,
              workNumber,
              pictures2,
              pictures3,
              pictures7,
              pictures4,
              pictures5,
              pictures6
            } = data
            this.ruleForm = {
              creditCode,
              id,
              entName,
              contact,
              contactTel,
              entType,
              address,
              workAddress,
              pictures,
              outputValue,
              businessIncome,
              totalExport,
              taxRevenue,
              totalProfit,
              grossSalary,
              totalResearch,
              fixAssets,
              totalAssets,
              workNumber,
              pictures2,
              pictures3,
              pictures7,
              pictures4,
              pictures5,
              pictures6
            }
            this.checkCommitment = true
            this.pictures = this.formateList(this.ruleForm.pictures)
            this.pictures2 = this.formateList(this.ruleForm.pictures2)
            this.pictures3 = this.formateList(this.ruleForm.pictures3)
            this.pictures7 = this.formateList(this.ruleForm.pictures7)
            this.pictures4 = this.formateList(this.ruleForm.pictures4)
            this.pictures5 = this.formateList(this.ruleForm.pictures5)
            this.pictures6 = this.formateList(this.ruleForm.pictures6)

            resolve()
          }
        })
      })
    },
    formateList(arr) {
      if (arr && arr.length) {
        let list = []
        arr.forEach((item) => {
          let obj = {
            name: item.fileName,
            url: item.ossUrl
          }
          list.push(obj)
        })
        return list
      } else {
        return []
      }
    },
    handleUploadSuccess(res, file, fileList, key) {
      let list = []
      fileList.forEach((item) => {
        if (item.response) {
          let data = item.response.data
          list.push({
            fileName: data.fileName,
            ossUrl: data.ossUrl
          })
        } else {
          list.push({
            fileName: item.name,
            ossUrl: item.url
          })
        }
      })
      this.ruleForm[key] = list
      if (this.rulesList.indexOf(key)) {
        this.$refs['ruleForm'].validateField(key)
      }
    },
    beforeUploadFile(file, List) {
      const allowFileTypes = ['doc', 'docx', 'xls', 'xlsx', 'png', 'jpg', 'pdf']
      const fileName = file.name.split('.')
      let fileType = fileName[fileName.length - 1]
      const isFile = allowFileTypes.includes(fileType.toLowerCase())
      if (!isFile) {
        this.$message.error(
          '上传文件只能是 doc、docx、xls、xlsx、pdf、jpg、pdf 格式!'
        )
      }
      return isFile
    },
    handleRemove(file, fileList, key) {
      let list = []
      fileList.forEach((item) => {
        if (item.response) {
          let data = item.response.data
          list.push({
            fileName: data.fileName,
            ossUrl: data.ossUrl
          })
        } else {
          list.push({
            fileName: item.name,
            ossUrl: item.url
          })
        }
      })
      this.ruleForm[key] = list
    },
    // 图片预览
    handlePreview(file) {
      console.log(file)
      const allowFileTypes = ['png', 'jpg']
      const fileName = file.name.split('.')
      let fileType = fileName[fileName.length - 1]
      const isFile = allowFileTypes.includes(fileType.toLowerCase())
      this.previewUrl = file.response ? file.response.data.ossUrl : file.url
      if (isFile) {
        this.isPreview = true
      } else {
        window.open(this.previewUrl, '_blank')
      }
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning('当前限制选择 5 个文件，已上传了5个文件')
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm
          insertOrUpdate(data).then((res) => {
            if (res.data.code == '0000') {
              this.$message.success(res.data.msg)
              this.backToList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    backToList() {
      this.$router.push({
        name: 'applyEntrance'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  .top-title {
    font-size: 14px;
    width: 100%;
    padding: 10px 20px;
    border-bottom: 1px solid #eee;
  }
  .left-box {
    flex: 1;
    height: 100%;
    overflow-y: auto;
    background: #fff;

    .form-box {
      padding: 20px;
      .col {
        display: flex;
        .col-form-item {
          width: 40%;
          margin-right: 50px;
        }
      }
    }
    /deep/ .el-form-item {
      margin-bottom: 10px;
    }
    /deep/ .el-form-item__label {
      float: none;
      word-break: break-word;
    }
    /deep/.el-form-item__content {
      margin-left: 0 !important;
    }
    .select-box {
      width: 100%;
    }
    .submitBtn {
      margin-left: 20px;
    }
  }
}
</style>

<style lang="scss">
.popover-back {
  .warningColor {
    color: orange;
    font-size: 16px;
  }
  .content {
    color: rgba(0, 0, 0, 0.45);
  }
  .flex {
    display: flex;
    justify-content: flex-start;
    p {
      margin: 0 10px 10px;
    }
  }
}
</style>
